import RecentItems from "metabase/entities/recent-items";
import HomeRecentSection from "../../components/HomeRecentSection";

export default RecentItems.loadList()(HomeRecentSection);
